export const PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_PER_PAGE: 25,
    DEFAULT_TOTAL_PAGES: 1
};
